import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { WithdrawalWithUser, FilterWithdrawalType } from "libs/dto/src/withdrawal";
import qs from "qs";

export type WithdrawalStats = {
  pendingCount: number;
  pendingAmount: number;
  paidCount7d: number;
  paidAmount7d: number;
  paidCountTotal: number;
  paidAmountTotal: number;
};

const withdrawal = async (page: number, filter?: FilterWithdrawalType | null, take: number = 5) => {
  if (filter) {
    const response = await axios.get<{ page: number; data: WithdrawalWithUser[] }>(`/withdrawals`, {
      params: {
        page: page,
        take: take,
        ...filter,
      },
      paramsSerializer: (params) => qs.stringify(params),
    });
    return response.data;
  }

  const response = await axios.get<{ page: number; data: WithdrawalWithUser[] }>(`/withdrawals`, {
    params: {
      page: page,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
  return response.data;
};

export const useWithdrawals = (
  page: number,
  filter?: FilterWithdrawalType | null,
  take: number = 5,
) => {
  const {
    data: withdrawals,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["withdrawals", page, filter, take],
    queryFn: () => withdrawal(page, filter, take),
  });

  return { withdrawals, loading, error };
};

/** KPIs finance de la console retraits (header + widget file d'attente). */
export const useWithdrawalStats = () => {
  const {
    data: stats,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["withdrawal-stats"],
    queryFn: async () => {
      const response = await axios.get<WithdrawalStats>("/withdrawals/stats");
      return response.data;
    },
    refetchInterval: 30000, // file vivante : rafraîchissement 30 s
  });
  return { stats, loading, error };
};
